import { DiJavascript1, DiSass } from "react-icons/di";
import styles from "./styles.module.css";

export const dataFileTopVscode = [
  {
    fileName: "File",
    id: 1,
  },
  {
    fileName: "Edit",
    id: 2,
  },
  {
    fileName: "Selection",
    id: 3,
  },
  {
    fileName: "View",
    id: 4,
  },
  {
    fileName: "Go",
    id: 5,
  },
  {
    fileName: "Run",
    id: 6,
  },
  {
    fileName: "Terminal",
    id: 7,
  },
  {
    fileName: "Help",
    id: 8,
  },
];

export const dataFileRunTopVscode = [
  {
    icon: <DiJavascript1 className={styles.js} />,
    fileName: "index.js",
    id: 1,
  },
  {
    icon: <DiSass className={styles.sass} />,
    fileName: "styles.scss",
    id: 2,
  },
];

export const dataTerminal = [
  {
    fileName: "PROBLEM",
    id: 1,
  },
  {
    fileName: "OUTPUT",
    id: 2,
  },
  {
    fileName: "TERMINAL",
    id: 3,
  },
  {
    fileName: "GITLENS",
    id: 4,
  },
  {
    fileName: "DEBUG CONSOLE",
    id: 5,
  },
];
